import React from 'react';
import { Dayjs } from 'dayjs';
import { DateRangePicker as ReusableDateRangePicker, Label16SemiBold } from 'components';
import { getDateFormatset } from 'utils';
import { fieldStyles } from '../styles';

interface DateRangePickerProps {
    viewFromDate: Dayjs | null;
    viewToDate: Dayjs | null;
    onFromDateChange: (date: Dayjs | null) => void;
    onToDateChange: (date: Dayjs | null) => void;
    fromError?: string;
    toError?: string;
}

export const DateRangePicker = ({
    viewFromDate,
    viewToDate,
    onFromDateChange,
    onToDateChange,
    fromError,
    toError,
}: DateRangePickerProps) => (
    <ReusableDateRangePicker
        viewFromDate={viewFromDate}
        viewToDate={viewToDate}
        onFromDateChange={onFromDateChange}
        onToDateChange={onToDateChange}
        fromLabel="View from *"
        toLabel="View to *"
        format={getDateFormatset()}
        showTitle
        titleComponent={<Label16SemiBold>Select Date Range</Label16SemiBold>}
        maxWidth="300px"
        gap="6px"
        fromError={fromError}
        toError={toError}
        fromFieldProps={{
            sx: fieldStyles,
            inputProps: { 'aria-label': 'View from date' },
        }}
        toFieldProps={{
            sx: fieldStyles,
            inputProps: { 'aria-label': 'View to date' },
        }}
    />
);